import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';

export const i18nProvider = polyglotI18nProvider(() => englishMessages, 'en', { allowMissing: true }); // <-- Polyglot won't throw an error on missing translations.
